export { default } from './InterlinkSection';
export * from './InterlinkSection';
export * from './types';
